<div class="mydocma-dialog-container" [class.mobile-mydocma-dialog-container]="mediaQueryService.isXs">
  <div class="mydocma-dialog-header">
    <mydocma-custom-mat-icon class="px-icon" *ngIf="mediaQueryService.isXs" [iconName]="'_app-px'"></mydocma-custom-mat-icon>
    <div class="mydocma-dialog-header-title">
      {{ data.dialogTitle | translate }}
    </div>
    <div>
      <button mat-icon-button type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="mydocma-dialog-body">
    <mydocma-loader class="mydocma-mm-loader" *ngIf="importing"></mydocma-loader>
    <mydocma-pix-file-selection

      *ngIf="data.fileOrigin === 'Pix' && project"
      [project]="project"
  [defaultDate]="data.defaultDate"
  [defaultMode]="TimeFrameEnum.Last_7_Days"
      [selectedFiles]="selectedFiles"
      [fileSelectionCacheService]="fileSelectionCacheService"
      [useLoaderWhileResolving]="true"
      [enableProjectSearch]="true"
      [isMobile]="isMobile"
      (onReady)="onReady($event)"
      (onFileSelectionChange)="changeSelection($event)"
      (onTagTreeVisibleChange)="onTagTreeVisibilityChanged($event)">
    </mydocma-pix-file-selection>
  </div>
  <div class="mydocma-dialog-footer" [class.mobile-mydocma-dialog-footer]="mediaQueryService.isXs" *ngIf="showFooter">
    <button mat-stroked-button type="submit" class="mydocma-btn" style="margin-right: 10px" (click)="onCancel()">
      {{ 'pix.cancel' | translate }}
    </button>
    <button mat-stroked-button type="button" class="mydocma-btn-primary" (click)="onDone()" [disabled]="selectedFiles?.length === 0 || importing">
      {{ buttonText }}
    </button>
  </div>
</div>
